export default {
    title: "EBC 파이낸셜 그룹 × 옥스퍼드 대학교 경제학과 | EBC 파이낸셜 그룹",
    description:
      "EBC 파이낸셜 그룹이 옥스퍼드 대학교와 함께 'What Economists Really Do(WERD)' 시리즈를 론칭하며 최고의 학자들과 기후 경제학 관련 주제를 논의합니다. 교육을 통해 투자자들에게 힘을 실어주고 투명하며 지속 가능한 미래를 함께 구축하는 방법을 알아보세요.",
    word1: "EBC 파이낸셜 그룹 × 옥스퍼드 대학교 경제학과",
    word2:
      "최첨단 연구와 현실 세계를 연결하며 글로벌 경제의 새로운 패러다임을 함께 설계합니다",
    word3: "하이라이트",
    word4: "협력의 여정에 동참하세요",
    word5: "협력 개요",
    word6: "WERD 이전 콘텐츠",
    word7: "특별 초청 인사",
    word8: "미디어 보도",
    word9: "우리는 믿습니다. 교육이 곧 미래를 바꾸는 힘이라는 것을.",
    word10:
      "EBC금융그룹은 ‘책임 있는 금융은 모두가 접근할 수 있는 지식에서 시작된다’는 믿음을 바탕으로, 옥스퍼드대학교 경제학부와 협력하여 세계 최고 수준의 경제 연구를 대중에게 선보이고 있습니다.",
    word11:
      "What Economists Really Do(WERD)' 시리즈를 통해 우리는 금융에 대한 이해력을 높이고 다음 세대의 투자자, 리더, 사상가들의 성장을 지원하고자 합니다.",
    word12:
      "이번 협력은 EBC의 핵심 가치인 공정성, 책임, 정직함에 깊이 뿌리를 두고 있으며,더 투명하고 포용적인 금융 미래를 구축하겠다는 우리의 확고한 약속을 상징합니다.",
    word13: "진실한 대화, 실질적인 영향",
    word14: "WERD 에피소드 1",
    word15: '"경제학자들은 실제로 무엇을 하는가"',
    word16: "이벤트 정보",
    word17:
      "세금 회피가 전 세계와 지역 경제에 미치는 구조적 영향을 함께 논의하며, 이러한 복잡한 문제를 풀어가는 데 있어 금융에 대한 이해가 얼마나 중요한지에 주목합니다.",
    word18: "게스트",
    word19: "Dr. Abi Adams, 옥스퍼드 대학교 경제학 교수, 진행자",
    word20: "Dr. Sarah Clifford, 옥스퍼드 대학교 경제학과 부교수",
    word21: "David Barrett, EBC Financial Group (UK) Ltd CEO, 공식 초청 게스트",
    word22: "이벤트 일정",
    word23: "2024년 3월 1일",
    word24: '("What Economists Really Do" 2023-2024 시리즈)',
    word25: "이벤트 형식",
    word26: "Zoom 온라인 라이브 스트리밍 리뷰",
    word27: "WERD 에피소드2",
    word28: "지속 가능한 성장의 실현: 경제 성장과 기후 회복력의 균형",
    word29: "글로벌 환경 위기에 대응하는 거시경제 정책의 역할을 조망합니다.",
    word30:
      "Banu Demir Pakel 박사\n세션 좌장 및 옥스퍼드대학교 대외협력 부국장, 경제학 교수",
    word31: "Andrea Chiavari 박사\n주제 발표자 및 패널 토론 연사",
    word32:
      "Nicola Ranger 박사\n옥스퍼드대학교 환경 변화 및 글로벌 금융 리서치 총괄, 선임 연구원",
    word33: "David Barrett EBC 파이낸셜 그룹(영국) CEO",
    word34: '2024년 11월호\n("What Economists Really Do" 2024-2025 edition) ',
    word35:
      "옥스퍼드대학교 경제학부 최초의 하이브리드 포럼 개최\n온라인과 오프라인을 병행하는 이번 세미나는 주요 전문가들과 함께하는 라운드테이블 토론을 포함합니다.",
    word36: "특별 초청 게스트",
    word37: "Nicola Ranger",
    word38: "옥스퍼드 대학교 환경 회복력 및 시스템 연구 책임자",
    word39:
      "\nNicola Ranger 박사는 현재 옥스퍼드대학교 환경 변화 연구소(ECI) 산하 환경 회복력 및 Martin 시스템 프로젝트를 이끌고 있습니다.\n그녀는 IMF, 세계은행, NGFS, 영국 기후금융리스크 포럼 등과 협력해, 기후 금융 스트레스 테스트 도구를 개발하는 글로벌 금융·경제 연구 그룹을 설립한 바 있습니다.\n또한, EU 지속가능 투자 전문가 그룹, 신흥시장 ESG 자문단, 영국 그린 테크 분류 자문 그룹, 영국 외교부, 런던정경대(LSE) 자문위원으로도 활발히 활동 중입니다.",
    word40: "Andrea Chiavari",
    word41: "옥스퍼드 대학교 경제학과 부교수",
    word42:
      "Andrea Chiavari 부교수는 거시경제학 전문가로 기업의 기술 변화를 연구합니다. 그의 연구는 경제 모델을 활용하여 지속 가능한 발전을 촉진하고, 기후 변화가 기업의 생산성과 자본 배분에 미치는 영향을 분석하며,불확실한 환경 속에서의 경제 효율성과 회복력 향상에 중점을 두고 있습니다.",
    word43: "Banu Demir Pakel",
    word44: "옥스퍼드 대학교 경제학과 부교수",
    word45:
      "Banu 부교수는 국제 무역과 발전 경제학의 교차 영역에 주목하며,\n무역 충격에 대한 기업의 대응 방식이 거시경제 성장과 소득 분배에 미치는 영향을 중점적으로 연구하고 있습니다.\n그녀는 유럽 경제정책연구센터(CEPR) 국제무역 및 지역경제 프로그램의 멤버이자,독일 뮌헨 CESifo 연구 네트워크의 구성원으로도 활발히 활동하고 있습니다.",
    word46: "데이비드 배럿",
    word47: "EBC  금융 그룹 영국 본사 CEO",
    word48:
      "데이비드 배렛(David Barrett)은 국제 자산 다각화 및 위험 관리 분야에서 35년 이상의 경험을 보유하고 있습니다. 그는 금융 규제 운영에 대한 풍부한 경험을 바탕으로 국제 금융 서비스, 비즈니스 전략 컨설팅, 금융 상품 구조화 등 분야에서 뛰어난 역량을 보이고 있으며, 업계 동향과 FCA 규제 요구 사항의 변화에 대한 통찰력 또한 뛰어납니다. 그는 세계 최대 투자 그룹인 미국 AIG에서 중요한 개혁을 주도하며 월가의 제품 구조화 및 규정 준수에 영향을 미쳤고, 금융 위기 이후 리스크 및 유동성 관리를 위한 프레임워크를 개발했습니다.",
    word49: "세라 클리포드",
    word50: "옥스퍼드 대학교 경제학부 부교수",
    word51:
      "옥스퍼드대학교의 “조세 회피 경제학” 분야에서 학문적 거목으로 손꼽히는 세라 클리포드 박사는 조세 회피 경제학의 근본 경제 원리와 세금 관련 경제적 행동 모델을 탐구하는 데 헌신하고 있습니다. \n\n교수는 다국적 기업(MNE)의 유효 세율(ETR)을 연구하기 위해 다국적 패널 데이터를 최초로 활용한 학자 중 한 명으로, 경제협력개발기구(OECD)의 세원 잠식과 관련된 “GloBE” 법안을 주도적으로 제안하며 BEPS(소득 이전 및 세원 잠식) 포괄적 프레임워크 구축에 크게 기여했습니다.\n\n최신 논문 《조세 회피의 글로벌 영향과 정책적 함의》에서 세라 클리포드 박사는 조세 회피 경제학이 세계 경제에 미치는 영향을 심층적으로 분석하고, 효과적인 정책 개입을 통해 이러한 현상을 완화할 수 있는 정부의 역할을 제시했습니다. 그녀의 연구는 조세 정책 설계와 글로벌 경제 거버넌스 개선에 중요한 방향성을 제공하고 있습니다.",
    word52: "아비 애덤스-프래슬",
    word53: "옥스퍼드 대학교 너필드 칼리지 부학장(외부 참여)",
    word54:
      "아비 애덤스 프래슬 교수는 응용 미시경제학을 전문으로 하며, 실증적 방법을 통해 데이터를 의사결정 모델에 통합함으로써 개인과 가정이 더 나은 결정을 내릴 수 있도록 돕는 데 중점을 둡니다.\n\n영국 정부 과학사무소(UK Government Office for Science) 전문가 그룹의 일원으로서, 영국 정부의 리스크 관리 및 회복력 계획을 주도했으며, 이를 단기적 관점에서 장기적 목표로 확장하는 데 기여했습니다. 또한, 학술 연구와 정책 연구를 아우르는 권위자로서, 영국 사법 체계 내에서 사법과 관련된 양적 프레임워크를 설계하고, 빅데이터 환경에서 사법 접근성과 개방성 간의 균형을 정립하는 데 중요한 역할을 했습니다.\n\n이러한 연구와 기여는 데이터 기반 정책 설계와 법적 의사결정의 혁신적 접근법을 강조하며, 경제학과 법학의 경계를 넘나드는 탁월한 학문적 성과를 보여줍니다.",
    word55: "자세히 알아보기",
    word56: "보도자료",
    word57: "함께 만드는 새로운 여정의 시작",
    word58:
      "EBC는 비전을 공유하는 기관 및 변화의 주체들과 함께 새로운 협력 가능성을 활발히 탐색하고 있습니다.",
    word59: "상담하기",
    placeholder1: "이름/닉네임",
    placeholder2: "이메일",
    placeholder3: "휴대폰 번호",
    placeholder4: "인증 코드",
}
